import { StrictMode } from "react";
import ReactDOM from "react-dom/client";
import { App } from "./App";
import reportWebVitals from "./reportWebVitals";
import { BrowserRouter } from "react-router-dom";
import store, { StoreContext } from './store';
import { ApolloProvider } from '@apollo/client';
import { client } from './Apollo';
import { MantineProvider } from '@mantine/core';
import { Notifications } from '@mantine/notifications';

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);

root.render(
  <StrictMode>
    <StoreContext.Provider value={store}>
      <BrowserRouter>
        <ApolloProvider client={client}>
          <MantineProvider theme={{ colorScheme: "dark" }} withNormalizeCSS withGlobalStyles>
            <Notifications />
            <App />
          </MantineProvider>
        </ApolloProvider>
      </BrowserRouter>
    </StoreContext.Provider>
  </StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
